import { useTranslation } from "react-i18next";
import {
  CompanyTokenKey,
  CONFIG_CSS_INTERNALLOGIN,
  STATUS_CODE_SERVER,
  LocalStorageParameterName
} from "../../Constants";
import * as ParameterConfig from "../../helpers/Parameter";
import * as TokenConfig from "../../helpers/CookieToken";
import { useCompanyStore } from "../../store";
import * as ApplicationServices from "../../services/templateServices/ApplicationServices";
import Cookies from "universal-cookie";
import { useSwal } from "../templateHooks/useSwal";
import { useUser } from "..";
import { useCompany } from "../templateHooks/useCompany";


export const useCurrentCompany = () => {
  const [t, i18n] = useTranslation("global");
  const { SelectSwal } = useSwal();
  const { GetCompanyByUser} = useUser();
  const CompanyHook = useCompany();

  const { Company, Application, MenuList ,  setCompany, setApplication, SelectedCompany, setSelectedCompany  } = useCompanyStore();


  const GetCurrentCompany = async () => {
    let ic= null;
    let params = new URL(window.location.href).searchParams;
    const paramIC = params.get(CompanyTokenKey);
    const cookies = new Cookies();
    if (paramIC) {
         ic = paramIC;
        cookies.remove(CompanyTokenKey.toUpperCase(),ic,{path:"/"});
        cookies.set(CompanyTokenKey.toUpperCase(), ic,{path:"/"});
    }else {
        ic = cookies.get(CompanyTokenKey.toUpperCase());   
    }

   let  ConpanyConfig = await TokenConfig.DesencryptKey(ic);
   
   if( ConpanyConfig.errorNumber !== STATUS_CODE_SERVER.NOT_FOUND){
      if(ConpanyConfig.errorNumber === STATUS_CODE_SERVER.BAD_REQUEST){
        return JSON.parse(ParameterConfig.GetValueParameter(CONFIG_CSS_INTERNALLOGIN));
      }else {
        return JSON.parse(ParameterConfig.GetValueParameter(ConpanyConfig));
      }
   }else {
    return ConpanyConfig;
   }
  };

  const setCurrentCompany = async (company) => {
    setCompany(company);
  };

  const setCurrentSelectedCompany = async (company) => {
    setSelectedCompany(company);
  };


  //Obtenemos la configuracion de la Applicacion en base ala compañia
  const GetApplication = async (CurCompany) => {
    if (!CurCompany) return;
    try {
      const app = await ApplicationServices.ApplicationCompany(
        CurCompany.IdCompany
      );
      setApplication(app);
    } catch (error) {
      console.log(`Error -> ${error}`);
    }
  };

  const GetMenuList = async (idUser, idApp = null) => {
    if (!idUser) return;
    try {
      const menuList = !idApp
        ? MenuList
        : await MenuServices.GetMenuApplication(
            idUser,
            i18n.language
              ? i18n.language === "es"
                ? "1"
                : "2"
              : DEFAULT_LENGUAJE === "en"
              ? "2"
              : "1",
            idApp
          );
          setMenuList(menuList);
    } catch (error) {
      console.log(`Error -> ${error}`);
    }
  };


  const GenerateCookieCompanySelcted = async (idCompany) => {
    let CompanyKeys = JSON.parse(localStorage.getItem(LocalStorageParameterName));
    CompanyKeys.filter((x) => x.code.includes("CONFIG_CSS")).forEach( async (x) => {
      let objCompany = JSON.parse(x.value);
      if (objCompany.IdCompany === idCompany) {
        let CompanySession = await CompanyHook.CompanyItem(idCompany);
        if(!CompanySession.errorMessage){
          debugger;
          await setCurrentCompany({...CompanySession,...objCompany});
          const ic = objCompany.IcKey
          const cookies = new Cookies();
          cookies.remove(CompanyTokenKey.toUpperCase(),ic,{path:"/"});
          cookies.set(CompanyTokenKey.toUpperCase(), ic,{path:"/"});
        }
      }
    });
  }

  const setUserCompanySelector  = async (idUser, CallbackSelector ) => {
      const CompanyRsltList = await GetCompanyByUser(idUser);
      if(!CompanyRsltList.errorMessage){
        SelectSwal(CompanyRsltList.filter(x=> x.idCompany !== 0 ).map(x=>  { return {  [x.idCompany] : x.companyName  }} ) , async (value) => {   
          await GenerateCookieCompanySelcted( parseInt(value));
          await CallbackSelector(); 
         });
      }
  }

  return {
    //Properties
    Company,
    Application,
    MenuList,
    SelectedCompany,
    //Methods
    GetCurrentCompany,
    setCurrentCompany,
    GetApplication,
    setUserCompanySelector,
    setCurrentSelectedCompany
  };
};
